const readMoreElements = [...document.querySelectorAll('.text__more')];

readMoreElements.forEach(element => {
    const textClassList = element.closest('.text').classList;

    element.addEventListener('click', () => {
        // console.log('click readMoreElement', element);
        textClassList.add('text--opened');
    });
});
